let counter = 0;

/** A key unique for the life of the page. */
export function mintKey(): string {
  counter += 1;
  return `row-${counter}`;
}

/**
 * Grow or shrink `keys` to exactly `length`, keeping existing keys in place.
 * Returns the same reference when no change is needed, so callers can use
 * identity to detect a resync.
 */
export function resizeKeys(
  keys: string[],
  length: number,
  mint: () => string = mintKey,
): string[] {
  if (keys.length === length) return keys;
  if (keys.length > length) return keys.slice(0, length);
  const next = [...keys];
  while (next.length < length) next.push(mint());
  return next;
}

/**
 * Move one key from `from` to `to`. Out-of-range or no-op moves return the
 * same reference.
 */
export function moveKeys(keys: string[], from: number, to: number): string[] {
  if (from === to) return keys;
  if (from < 0 || to < 0 || from >= keys.length || to >= keys.length) return keys;
  const next = [...keys];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}
